/**
 * Class component based on:
 * https://dev.to/megazear7/the-vanilla-javascript-component-pattern-37la
 */
import {
  selectDoc,
  selectArr, event, removeClassAll
} from "../utils/utils";

export class RingSizer {
  /**
   * Account constructor
   * @param container
   */
  constructor(container) {
    if (selectDoc(container)) {
      this.init();
    }
  }

  /**
   * Initialize class
   */
  init() {
    this.props();
    this.initRingSizeSearch();
  }

  /**
   * Initialize class props
   */
  props() {
    this.searchSelect = selectDoc('.ringsizer-section #mm-size')
    this.searchResult = selectDoc('.ringsizer-section #mm-result')
  }

  /**
   *
   */
  initRingSizeSearch() {
    let self = this;
    const search = () => {
      if(self.searchSelect) {
        if(self.searchSelect.selectedIndex > 0) {
          self.searchResult.innerText = self.searchSelect.value
          self.searchSelect.style.width =  `${self.searchSelect.options[self.searchSelect.selectedIndex].innerText.length * 10}px`
        } else {
          self.searchResult.innerText = '-'
          self.searchSelect.style.width =  `auto`
        }
      }
    }

    event(this.searchSelect, 'change', search);
  }
}
